import type { MatchFilters } from "./matchFiltersSchema";

// Все фильтры выключены: «Сбросить всё».
export const NO_FILTERS: MatchFilters = {
  mode: undefined,
  result: undefined,
  heroes: undefined,
  period: undefined,
  from: undefined,
  to: undefined,
  analyzed: undefined,
  duration: undefined,
  deaths: undefined,
  place: undefined,
};
